import cloneDeep from 'lodash/cloneDeep';
import isPlainObject from 'lodash/isPlainObject';
import runMingo from './runMingo';
const calculateDerivedProps = (state) => {
    const cloned = cloneDeep(state);
    const hasCalculate = (prop) => !!(prop && typeof prop === 'object' && prop._calculate);
    const recurseAndCalculateProps = (obj) => {
        const keys = Object.keys(obj);
        const calculated = keys.reduce((prev, current) => {
            let value = obj[current];
            if (isPlainObject(value)) {
                value = recurseAndCalculateProps(value);
            }
            if (hasCalculate(value)) {
                const expression = value._calculate;
                const { value: result = null, error } = runMingo(expression, cloned);
                if (error) {
                    // eslint-disable-next-line no-console
                    console.warn(error);
                }
                value = result;
            }
            return { ...prev, [current]: value };
        }, {});
        return calculated;
    };
    return recurseAndCalculateProps(cloned);
};
export default calculateDerivedProps;
